// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#rma_main{display:grid}#rma_iframe{width:100%;height:calc(100vh - 70.84px);border:none}", "",{"version":3,"sources":["webpack://ClientApp/app/views/rma/rma.scss"],"names":[],"mappings":"AACA,UACE,YACF,CAEA,YACE,UAAW,CACX,4BAA6B,CAC7B,WACF","sourcesContent":["/*$color_arec_darkblue: #004C8A;*/\n#rma_main {\n  display: grid;\n}\n\n#rma_iframe {\n  width: 100%;\n  height: calc(100vh - 70.84px);\n  border: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
